import { useState } from "react";
import { Target, Grid3x3, GraduationCap } from "lucide-react";
import OSLayout from "../../components/os/OSLayout";
import PerformanceStudio from "./PerformanceStudio";
import Skills from "./Skills";
import LearningStudio from "./LearningStudio";

// Lote 4 — Módulo único de Gestión de Talento por empresa. Fusiona Desempeño
// (objetivos, evaluaciones, 1:1, feedback continuo), Competencias y Aprendizaje.
// Las apps duplicadas del motor redirigen aquí.
const PILLARS = [
  { key: "desempeno", label: "Desempeño", icon: Target, Comp: PerformanceStudio },
  { key: "competencias", label: "Competencias", icon: Grid3x3, Comp: Skills },
  { key: "aprendizaje", label: "Aprendizaje", icon: GraduationCap, Comp: LearningStudio },
];

export default function GestionTalento() {
  const params = new URLSearchParams(window.location.search);
  const initial = params.get("tab");
  const [tab, setTab] = useState(PILLARS.some((p) => p.key === initial) ? initial : "desempeno");
  const Active = PILLARS.find((p) => p.key === tab)?.Comp || PerformanceStudio;

  return (
    <OSLayout title="Gestión de Talento">
      <div className="space-y-6" data-testid="talent-hub">
        <div>
          <div className="overline text-navy/40 mb-2 flex items-center gap-2"><Target className="w-3.5 h-3.5" /> OMNIA People Suite · Talento</div>
          <h2 className="font-editorial text-4xl md:text-5xl tracking-tight">Gestión de Talento</h2>
          <p className="mt-2 text-navy/50 max-w-2xl">Desempeño, competencias y aprendizaje en un solo módulo por empresa.</p>
        </div>

        <div className="flex flex-wrap gap-2 border-b border-navy/10 pb-2">
          {PILLARS.map((p) => (
            <button key={p.key} onClick={() => setTab(p.key)} data-testid={`talent-pillar-${p.key}`}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm transition-colors ${tab === p.key ? "bg-navy text-cream" : "text-navy/55 hover:text-navy hover:bg-navy/5"}`}>
              <p.icon className="w-4 h-4" /> {p.label}
            </button>
          ))}
        </div>

        <div data-testid={`talent-panel-${tab}`}>
          <Active embedded />
        </div>
      </div>
    </OSLayout>
  );
}
